import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import VideoCard from '@/components/base/VideoCard';
import CategoryTag from '@/components/base/CategoryTag';
import SEOMeta from '@/components/base/SEOMeta';
import { categories } from '@/mocks/categories';
import { videos, getHotVideos, getNewVideos } from '@/mocks/videos';

export default function Home() {
  const [searchQuery, setSearchQuery] = useState('');
  const hotVideos = getHotVideos();
  const newVideos = getNewVideos();
  const latestVideos = videos.filter((v) => !v.isHot && !v.isNew).slice(0, 4);
  const trendingAll = [...hotVideos, ...newVideos].slice(0, 6);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料在线观看',
    url: 'https://heiliao-online.com',
    description: '黑料在线观看平台，汇聚最新最全黑料视频资源，支持免费在线播放，无需下载，高清流畅观看体验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://heiliao-online.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料在线观看',
    url: 'https://heiliao-online.com',
    description: '最新最全的视频内容平台，提供免费在线观看服务',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-0000',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <SEOMeta
        title="黑料在线观看-最新黑料视频免费播放 | 黑料在线"
        description="黑料在线观看平台，汇聚最新最全黑料视频资源，支持免费在线播放，无需下载，高清流畅观看体验。第一时间获取热门黑料内容，实时更新，海量资源任意浏览，让你不错过任何精彩黑料内容。"
        keywords="黑料在线观看,黑料视频在线播放,最新黑料免费看,黑料高清在线,热门黑料视频,黑料资源网站,黑料内容更新"
        canonicalUrl="https://heiliao-online.com"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20video%20content%20platform%20with%20warm%20cinematic%20lighting%2C%20entertainment%20media%20hub%2C%20professional%20broadcast%20studio%20atmosphere%2C%20editorial%20photography&width=1200&height=630&seq=og-home-2026&orientation=landscape"
        schemaData={[websiteSchema, orgSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dynamic%20modern%20media%20broadcast%20studio%20with%20warm%20coral%20and%20gold%20cinematic%20lighting%2C%20multiple%20large%20screens%20displaying%20video%20content%2C%20professional%20production%20environment%2C%20immersive%20atmosphere%2C%20high-end%20editorial%20photography%20with%20dramatic%20shadows&width=1800&height=600&seq=hero-bg-2026-01&orientation=landscape"
            alt="黑料在线观看 - 最新视频内容平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
            <div className="w-full max-w-3xl text-center">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 leading-tight">
                最新<strong className="text-primary-400">黑料视频</strong>免费在线观看
              </h1>
              <p className="text-sm md:text-lg text-background-100/90 mb-8 max-w-2xl mx-auto leading-relaxed">
                汇聚最新最全热门视频资源，高清流畅观看体验，第一时间获取精彩内容，海量资源任意浏览
              </p>

              <div className="relative max-w-xl mx-auto">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索你感兴趣的视频内容..."
                  className="w-full px-5 py-3.5 pl-12 rounded-full bg-background-50/95 text-foreground-900 placeholder-foreground-400 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 shadow-lg"
                />
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
        </section>

        {/* Categories Section */}
        <section className="w-full px-4 md:px-6 py-8 md:py-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950">
                热门分类
              </h2>
              <Link to="/category/hot" className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap">
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-4 md:grid-cols-8 gap-3">
              {categories.map((cat) => (
                <CategoryTag
                  key={cat.id}
                  slug={cat.slug}
                  name={cat.name}
                  icon={cat.icon}
                  variant="card"
                />
              ))}
            </div>
          </div>
        </section>

        {/* Trending Videos */}
        <section className="w-full px-4 md:px-6 py-6 md:py-10 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-fire-line text-accent-600 text-base"></i>
              </div>
              <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950">
                热门推荐
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {trendingAll.map((video) => (
                <VideoCard
                  key={video.id}
                  id={video.id}
                  title={video.title}
                  thumbnail={video.thumbnail}
                  duration={video.duration}
                  views={video.views}
                  date={video.date}
                  category={video.category}
                  categoryName={categories.find((c) => c.slug === video.category)?.name || video.category}
                  isHot={video.isHot}
                  variant="large"
                />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Videos Grid */}
        <section className="w-full px-4 md:px-6 py-8 md:py-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-timer-flash-line text-primary-600 text-base"></i>
              </div>
              <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950">
                最新更新
              </h2>
            </div>

            {/* Featured Hot */}
            {hotVideos.length > 0 && (
              <div className="mb-10">
                <div className="flex items-center gap-2 mb-4">
                  <span className="w-1 h-4 bg-primary-500 rounded-full"></span>
                  <h3 className="text-base font-bold font-heading text-foreground-900">热门爆料</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  {hotVideos.map((video) => (
                    <VideoCard
                      key={video.id}
                      id={video.id}
                      title={video.title}
                      thumbnail={video.thumbnail}
                      duration={video.duration}
                      views={video.views}
                      date={video.date}
                      category={video.category}
                      categoryName={categories.find((c) => c.slug === video.category)?.name || video.category}
                      isHot={video.isHot}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Latest Normal */}
            {latestVideos.length > 0 && (
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <span className="w-1 h-4 bg-secondary-500 rounded-full"></span>
                  <h3 className="text-base font-bold font-heading text-foreground-900">更多视频</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  {latestVideos.map((video) => (
                    <VideoCard
                      key={video.id}
                      id={video.id}
                      title={video.title}
                      thumbnail={video.thumbnail}
                      duration={video.duration}
                      views={video.views}
                      date={video.date}
                      category={video.category}
                      categoryName={categories.find((c) => c.slug === video.category)?.name || video.category}
                      isHot={video.isHot}
                    />
                  ))}
                </div>
              </div>
            )}

            <div className="text-center mt-10">
              <Link
                to="/category/hot"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors shadow-sm whitespace-nowrap"
              >
                浏览更多内容 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full px-4 md:px-6 py-16 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20modern%20media%20lounge%20with%20comfortable%20seating%20and%20large%20display%20screens%2C%20inviting%20atmosphere%2C%20soft%20golden%20ambient%20lighting%2C%20entertainment%20hub%20environment%2C%20editorial%20interior%20photography&width=1800&height=400&seq=cta-bg-2026&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/45"></div>
          <div className="relative max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
              不错过任何精彩内容
            </h2>
            <p className="text-sm md:text-base text-background-200 mb-8">
              每日更新海量视频资源，高清流畅，免费观看，随时随地享受精彩内容
            </p>
            <Link
              to="/category/hot"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full font-semibold text-sm hover:bg-accent-600 transition-all duration-200 shadow-sm whitespace-nowrap"
            >
              立即开始浏览 <i className="ri-play-circle-line text-lg"></i>
            </Link>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}